module.exports = __webpack_public_path__ + "img/cook.c12e7754.png";